import { useEffect } from "react";
import { Toaster } from "react-hot-toast";
import { Navigate, Route, Routes } from "react-router-dom";
import { Protected } from "./components/layout/Protected";
import { RestrictedRoute } from "./routes";
import { RoutesMap } from "./types/common/routes";
import { UsersView } from "./views/Users/Users";
import { LoginView } from "./views/Login/LoginView";
import { useAuthStore } from "./hooks/useAuthStore";
import { useSelector } from "./redux/store";
import { AuthStatus } from "./types";
import { Backdrop, CircularProgress } from "@mui/material";
import { CompaniesView } from "./views/Companies/Companies";
import { SalesDocumentView } from "./views/SalesDocument/SalesDocument";
import { WayToPayView } from "./views/WayToPay/WayToPay";
import { BranchOfficesView } from "./views/BranchOffices/BranchOffices";
import { StoreView } from "./views/Store/Store";
import { ProductAttributesView } from "./views/ProductAttributes/ProductAttributes";
import { ProductUsageAttributesView } from "./views/ProductUsageAttributes/ProductUsageAttributes";
import { SpecificAttributesView } from "./views/SpecificAttributes/SpecificAttributes";
import { CategoryView } from "./views/Category/Category";
import { SubCategoryView } from "./views/Subcategory/SubCategory";
import { ProductsView } from "./views/Products/Products";
import { SuppliersView } from "./views/Suppliers/Suppliers";
import { ListOfProductsView } from "./views/ListOfProducts/ListOfProducts";
import { SpecificSubcategoryView } from "./views/SpecificSubcategory/SpecificSubcategory";
import { SearcherKFC } from "./views/Searcher/SearcherKFC";
import { SpecificUsesView } from "./views/SpecificUses/SpecificUses";
import { PriceListView } from "./views/PriceList/PriceList";
import { TypeProductsView } from "./views/TypeProducts/TypeProducts";
import { BussinesAreaView } from "./views/BussinesArea/BussinesArea";
import { ProductClassificationView } from "./views/ProductClassification/ProductClassification";
import { PreviewDocument } from "./views/Searcher/PreviewDocument";
import { Segments } from "./views/Segments/Segments";
import { SearcherV2 } from "./views/SearcherV2/SearcherV2";
import { SalesChannels } from "./views/SaleChannel/SalesChannels";
import { SellersView } from "./views/Sellers/Sellers";
import SearcherV3 from "./views/SearcherV3/SearcherV3";
import { PermissionsByUserType } from "./views/Settings/PermissionsByUserType";
import { ImportERP } from "./views/Import/ImportERP";
import { ShoppingCartListV3 } from "./views/SearcherV3/components/ShoppingCartListV3";
import { TicketListV3 } from "./views/SearcherV3/components/TicketListV3";
import { SalesList } from "./views/Sales/SalesList";
import { ImportWarehouseERP } from "./views/Import/ImportWarehouseERP";
import { ImportBusinessAreaERP } from "./views/Import/ImportBusinessAreaERP";
import { ImportWayToPayERP } from "./views/Import/ImportWayToPayERP";
import { ImportProductERP } from "./views/Import/ImportProductERP";
import { ImportCategoryERP } from "./views/Import/ImportCategoryERP";
import { ImportSubcategoryERP } from "./views/Import/ImportSubcategoryERP";
import { AdministratorList } from "./views/Administrator/AdministratorList";
import { InformationCompany } from "./views/Information/InformationCompany";
import { InitialStepList } from "./views/InitialStep/InitialStepList";
import { ImportSpecificSubcategory } from "./views/Import/ImportSpecificSubcategory";
import { ImportCustomer } from "./views/Import/ImportCustomer";
import { ImportSupplier } from "./views/Import/ImportSupplier";
import { PlanList } from "./views/Plan/PlanList";
import { PlanInitialStepList } from "./views/Plan/PlanInitialStepList";
import { ImportList } from "./views/Import/ImportList";
import { ImportBranch } from "./views/Import/ImportBranch";
import { IntegrationByUserView } from "./views/Settings/IntegrationByUser";
import { TypeAttributesView } from "./views/TypeAttributes/TypeAttributes";
import { SearcherCompany } from "./views/Searchers/SearcherCompany";
import { OrderList } from "./views/Order/OrderList";
import { IntakeCart } from "./views/IntakeCart/IntakeCart";
import { ProductEntryPreview } from "./views/ProductEntry/ProductEntryPreview";
import { StockProduct } from "./views/StockProduct/StockProduct";
import { AccountReceivable } from "./views/AccountReceivable/AccountReceivable";
import { NCList } from "./views/NC/NCList";
import { PaymentEnteredList } from "./views/Payment/PaymentEnteredList";
import { Cartola } from "./views/Cartola/Cartola";
import { ProductCostList } from "./views/Products/ProductCostList";
import { DispatchGuideList } from "./views/DispatchGuide/DispatchGuideList";
import { StoreDisabledView } from "./views/Store/StoreDisabled";
import { ClientOrderList } from "./views/Order/ClientOrderList";
import { ClientPreviewTicket } from "./views/Searcher/ClientPreviewTicket/ClientPreviewTicket";
import { DriverList } from "./views/Driver/DriverList/DriverList";
import { PatentList } from "./views/Patent/PatentList/PatentList";
import { useBatchStore } from "./hooks/useBatchStore";
import BatchProgressModal from "./components/common/BatchProgressModal/BatchProgressModal";

function App() {

    /* hooks */
    const { verifySession, status, user } = useAuthStore();
    const { isOpen } = useBatchStore();

    const { alertType, message, show } = useSelector((state) => state.snackbarSlice);
    const { showBackdrop } = useSelector((state) => state.backdropSlice);

    useEffect(() => {
        verifySession();
    }, []);

    if (status === AuthStatus.VERIFYING) {
        return (
            <Backdrop open={true}>
                <CircularProgress color="inherit" />
            </Backdrop>
        );
    }

    if (isOpen) {
         <BatchProgressModal/>
    }

    return (
        <>
            <Routes>
                {/* RUTAS PUBLICAS */}

                {/* RUTAS PRIVADAS */}
                {
                    status === AuthStatus.NOT_AUTHENTICATED ? (
                        <>
                            <Route path="/login" element={<LoginView />} />
                            <Route path="/*" element={<Navigate to={RoutesMap.LOGIN} replace />} />
                        </>
                    ) : (
                        <>
                            <Route path="/" element={<Protected />}>

                                <Route element={<RestrictedRoute pathRequired={RoutesMap.COMPANIES} />}>
                                    <Route path={RoutesMap.COMPANIES} element={<CompaniesView />} />
                                </Route>
                                <Route element={<RestrictedRoute pathRequired={RoutesMap.USERS} />}>
                                    <Route path={RoutesMap.USERS} element={<UsersView />} />
                                </Route>
                                <Route element={<RestrictedRoute pathRequired={RoutesMap.SALES_DOCUMENT} />}>
                                    <Route path={RoutesMap.SALES_DOCUMENT} element={<SalesDocumentView />} />
                                </Route>
                                <Route element={<RestrictedRoute pathRequired={RoutesMap.WAY_TO_PAY} />}>
                                    <Route path={RoutesMap.WAY_TO_PAY} element={<WayToPayView />} />
                                </Route>
                                <Route element={<RestrictedRoute pathRequired={RoutesMap.BRANCH_OFFICES} />}>
                                    <Route path={RoutesMap.BRANCH_OFFICES} element={<BranchOfficesView />} />
                                </Route>
                                <Route element={<RestrictedRoute pathRequired={RoutesMap.WAREHOUSE} />}>
                                    <Route path={RoutesMap.WAREHOUSE} element={<StoreView />} />
                                </Route>
                                <Route element={<RestrictedRoute pathRequired={RoutesMap.WAREHOUSE_DISABLED} />}>
                                    <Route path={RoutesMap.WAREHOUSE_DISABLED} element={<StoreDisabledView />} />
                                </Route>
                                <Route element={<RestrictedRoute pathRequired={RoutesMap.BUSSINES_AREA} />}>
                                    <Route path={RoutesMap.BUSSINES_AREA} element={<BussinesAreaView />} />
                                </Route>
                                <Route element={<RestrictedRoute pathRequired={RoutesMap.TYPE_ATTRIBUTES} />}>
                                    <Route path={RoutesMap.TYPE_ATTRIBUTES} element={<TypeAttributesView />} />
                                </Route>
                                <Route element={<RestrictedRoute pathRequired={RoutesMap.PRODUCT_ATTRIBUTES} />}>
                                    <Route path={RoutesMap.PRODUCT_ATTRIBUTES} element={<ProductAttributesView />} />
                                </Route>
                                <Route element={<RestrictedRoute pathRequired={RoutesMap.PRODUCT_USAGE_ATTRIBUTES} />}>
                                    <Route path={RoutesMap.PRODUCT_USAGE_ATTRIBUTES} element={<ProductUsageAttributesView />} />
                                </Route>
                                <Route element={<RestrictedRoute pathRequired={RoutesMap.SPECIFIC_PRODUCT_ATTRIBUTES} />}>
                                    <Route path={RoutesMap.SPECIFIC_PRODUCT_ATTRIBUTES} element={<SpecificAttributesView />} />
                                </Route>
                                <Route element={<RestrictedRoute pathRequired={RoutesMap.SPECIFIC_PRODUCT_USES} />}>
                                    <Route path={RoutesMap.SPECIFIC_PRODUCT_USES} element={<SpecificUsesView />} />
                                </Route>
                                <Route element={<RestrictedRoute pathRequired={RoutesMap.CATEGORIES} />}>
                                    <Route path={RoutesMap.CATEGORIES} element={<CategoryView />} />
                                </Route>
                                <Route element={<RestrictedRoute pathRequired={RoutesMap.SUB_CATEGORIES} />}>
                                    <Route path={RoutesMap.SUB_CATEGORIES} element={<SubCategoryView />} />
                                </Route>
                                <Route element={<RestrictedRoute pathRequired={RoutesMap.SPECIFIC_SUB_CATEGORIES} />}>
                                    <Route path={RoutesMap.SPECIFIC_SUB_CATEGORIES} element={<SpecificSubcategoryView />} />
                                </Route>
                                <Route element={<RestrictedRoute pathRequired={RoutesMap.TYPE_PRODUCTS} />}>
                                    <Route path={RoutesMap.TYPE_PRODUCTS} element={<TypeProductsView />} />
                                </Route>
                                <Route element={<RestrictedRoute pathRequired={RoutesMap.CLASSIFICATION_PRODUCTS} />}>
                                    <Route path={RoutesMap.CLASSIFICATION_PRODUCTS} element={<ProductClassificationView />} />
                                </Route>
                                <Route element={<RestrictedRoute pathRequired={RoutesMap.PRODUCTS} />}>
                                    <Route path={RoutesMap.PRODUCTS} element={<ProductsView />} />
                                </Route>
                                <Route element={<RestrictedRoute pathRequired={RoutesMap.LIST_OF_PRODUCTS} />}>
                                    <Route path={RoutesMap.LIST_OF_PRODUCTS} element={<ListOfProductsView />} />
                                </Route>
                                <Route element={<RestrictedRoute pathRequired={RoutesMap.PRICE_LIST} />}>
                                    <Route path={RoutesMap.PRICE_LIST} element={<PriceListView />} />
                                </Route>
                                <Route element={<RestrictedRoute pathRequired={RoutesMap.SUPPLIER_CUSTOMER} />}>
                                    <Route path={RoutesMap.SUPPLIER_CUSTOMER} element={<SuppliersView />} />
                                </Route>
                                <Route element={<RestrictedRoute pathRequired={RoutesMap.SEARCHER_KFC} />}>
                                    <Route path={RoutesMap.SEARCHER_KFC} element={<SearcherKFC />} />
                                </Route>
                                <Route element={<RestrictedRoute pathRequired={RoutesMap.SEARCHER_V2} />}>
                                    <Route path={RoutesMap.SEARCHER_V2} element={<SearcherV2 />} />
                                </Route>
                                <Route element={<RestrictedRoute pathRequired={RoutesMap.SEARCHER_V3} />}>
                                    <Route path={RoutesMap.SEARCHER_V3} element={<SearcherV3 />} />
                                </Route>
                                <Route element={<RestrictedRoute pathRequired={RoutesMap.PREVIEW_DOCUMENT} />}>
                                    <Route path={RoutesMap.PREVIEW_DOCUMENT} element={<PreviewDocument />} />
                                </Route>
                                <Route element={<RestrictedRoute pathRequired={RoutesMap.SEGMENTS} />}>
                                    <Route path={RoutesMap.SEGMENTS} element={<Segments />} />
                                </Route>
                                <Route element={<RestrictedRoute pathRequired={RoutesMap.SALE_CHANNEL} />}>
                                    <Route path={RoutesMap.SALE_CHANNEL} element={<SalesChannels />} />
                                </Route>
                                <Route element={<RestrictedRoute pathRequired={RoutesMap.SELLER} />}>
                                    <Route path={RoutesMap.SELLER} element={<SellersView />} />
                                </Route>
                                <Route element={<RestrictedRoute pathRequired={RoutesMap.PERMISSIONS_BY_USER} />}>
                                    <Route path={RoutesMap.PERMISSIONS_BY_USER} element={<PermissionsByUserType />} />
                                </Route>
                                <Route element={<RestrictedRoute pathRequired={RoutesMap.INTEGRATION_BY_USER} />}>
                                    <Route path={RoutesMap.INTEGRATION_BY_USER} element={<IntegrationByUserView />} />
                                </Route>
                                <Route element={<RestrictedRoute pathRequired={RoutesMap.IMPORT_ERP} />}>
                                    <Route path={RoutesMap.IMPORT_ERP} element={<ImportERP />} />
                                </Route>
                                <Route element={<RestrictedRoute pathRequired={RoutesMap.SHOPPING_CART_V3} />}>
                                    <Route path={RoutesMap.SHOPPING_CART_V3} element={<ShoppingCartListV3 />} />
                                </Route>
                                <Route element={<RestrictedRoute pathRequired={RoutesMap.TICKET_LIST_V3} />}>
                                    <Route path={RoutesMap.TICKET_LIST_V3} element={<TicketListV3 />} />
                                </Route>
                                <Route element={<RestrictedRoute pathRequired={RoutesMap.SALES_LIST} />}>
                                    <Route path={RoutesMap.SALES_LIST} element={<SalesList />} />
                                </Route>
                                <Route element={<RestrictedRoute pathRequired={RoutesMap.NC_LIST} />}>
                                    <Route path={RoutesMap.NC_LIST} element={<NCList />} />
                                </Route>
                                <Route element={<RestrictedRoute pathRequired={RoutesMap.DG_LIST} />}>
                                    <Route path={RoutesMap.DG_LIST} element={<DispatchGuideList />} />
                                </Route>
                                <Route element={<RestrictedRoute pathRequired={RoutesMap.IMPORT_WAREHOUSE} />}>
                                    <Route path={RoutesMap.IMPORT_WAREHOUSE} element={<ImportWarehouseERP />} />
                                </Route>
                                <Route element={<RestrictedRoute pathRequired={RoutesMap.IMPORT_BUSINESS_AREA} />}>
                                    <Route path={RoutesMap.IMPORT_BUSINESS_AREA} element={<ImportBusinessAreaERP />} />
                                </Route>
                                <Route element={<RestrictedRoute pathRequired={RoutesMap.IMPORT_WAY_TO_PAY} />}>
                                    <Route path={RoutesMap.IMPORT_WAY_TO_PAY} element={<ImportWayToPayERP />} />
                                </Route>
                                <Route element={<RestrictedRoute pathRequired={RoutesMap.IMPORT_PRODUCT} />}>
                                    <Route path={RoutesMap.IMPORT_PRODUCT} element={<ImportProductERP />} />
                                </Route>
                                <Route element={<RestrictedRoute pathRequired={RoutesMap.IMPORT_CATEGORY} />}>
                                    <Route path={RoutesMap.IMPORT_CATEGORY} element={<ImportCategoryERP />} />
                                </Route>
                                <Route element={<RestrictedRoute pathRequired={RoutesMap.IMPORT_SUBCATEGORY} />}>
                                    <Route path={RoutesMap.IMPORT_SUBCATEGORY} element={<ImportSubcategoryERP />} />
                                </Route>
                                <Route element={<RestrictedRoute pathRequired={RoutesMap.IMPORT_SPECIFIC_SUBCATEGORY} />}>
                                    <Route path={RoutesMap.IMPORT_SPECIFIC_SUBCATEGORY} element={<ImportSpecificSubcategory />} />
                                </Route>
                                <Route element={<RestrictedRoute pathRequired={RoutesMap.IMPORT_CUSTOMER} />}>
                                    <Route path={RoutesMap.IMPORT_CUSTOMER} element={<ImportCustomer />} />
                                </Route>
                                <Route element={<RestrictedRoute pathRequired={RoutesMap.IMPORT_SUPPLIER} />}>
                                    <Route path={RoutesMap.IMPORT_SUPPLIER} element={<ImportSupplier />} />
                                </Route>
                                <Route element={<RestrictedRoute pathRequired={RoutesMap.ADMIN_LIST} />}>
                                    <Route path={RoutesMap.ADMIN_LIST} element={<AdministratorList />} />
                                </Route>
                                <Route element={<RestrictedRoute pathRequired={RoutesMap.INFORMATION} />}>
                                    <Route path={RoutesMap.INFORMATION} element={<InformationCompany />} />
                                </Route>
                                <Route element={<RestrictedRoute pathRequired={RoutesMap.INITIAL_STEP_LIST} />}>
                                    <Route path={RoutesMap.INITIAL_STEP_LIST} element={<InitialStepList />} />
                                </Route>
                                <Route element={<RestrictedRoute pathRequired={RoutesMap.PLANS_LIST} />}>
                                    <Route path={RoutesMap.PLANS_LIST} element={<PlanList />} />
                                </Route>
                                <Route element={<RestrictedRoute pathRequired={RoutesMap.PLAN_INITIAL_STEP_LIST} />}>
                                    <Route path={RoutesMap.PLAN_INITIAL_STEP_LIST} element={<PlanInitialStepList />} />
                                </Route>
                                <Route element={<RestrictedRoute pathRequired={RoutesMap.IMPORT_LIST} />}>
                                    <Route path={RoutesMap.IMPORT_LIST} element={<ImportList />} />
                                </Route>
                                <Route element={<RestrictedRoute pathRequired={RoutesMap.IMPORT_BRANCH} />}>
                                    <Route path={RoutesMap.IMPORT_BRANCH} element={<ImportBranch />} />
                                </Route>
                                <Route element={<RestrictedRoute pathRequired={RoutesMap.SEARCHER_COMPANY} />}>
                                    <Route path={RoutesMap.SEARCHER_COMPANY} element={<SearcherCompany />} />
                                </Route>
                                <Route element={<RestrictedRoute pathRequired={RoutesMap.MY_ORDERS} />}>
                                    <Route path={RoutesMap.MY_ORDERS} element={<OrderList />} />
                                </Route>
                                <Route element={<RestrictedRoute pathRequired={RoutesMap.INTAKE_CART} />}>
                                    <Route path={RoutesMap.INTAKE_CART} element={<IntakeCart />} />
                                </Route>
                                <Route element={<RestrictedRoute pathRequired={RoutesMap.PRODUCT_ENTRY_PREVIEW} />}>
                                    <Route path={RoutesMap.PRODUCT_ENTRY_PREVIEW} element={<ProductEntryPreview />} />
                                </Route>
                                <Route element={<RestrictedRoute pathRequired={RoutesMap.STOCK_PRODUCT} />}>
                                    <Route path={RoutesMap.STOCK_PRODUCT} element={<StockProduct />} />
                                </Route>
                                <Route element={<RestrictedRoute pathRequired={RoutesMap.ACCOUNT_RECEIVABLE} />}>
                                    <Route path={RoutesMap.ACCOUNT_RECEIVABLE} element={<AccountReceivable />} />
                                </Route>
                                <Route element={<RestrictedRoute pathRequired={RoutesMap.PAYMENT_ENTERED} />}>
                                    <Route path={RoutesMap.PAYMENT_ENTERED} element={<PaymentEnteredList />} />
                                </Route>
                                <Route element={<RestrictedRoute pathRequired={RoutesMap.CARTOLA} />}>
                                    <Route path={RoutesMap.CARTOLA} element={<Cartola />} />
                                </Route>
                                <Route element={<RestrictedRoute pathRequired={RoutesMap.PRODUCT_COST_LIST} />}>
                                    <Route path={RoutesMap.PRODUCT_COST_LIST} element={<ProductCostList />} />
                                </Route>
                                <Route element={<RestrictedRoute pathRequired={RoutesMap.CLIENT_ORDER_LIST} />}>
                                    <Route path={RoutesMap.CLIENT_ORDER_LIST} element={<ClientOrderList />} />
                                </Route>
                                <Route element={<RestrictedRoute pathRequired={RoutesMap.CLIENT_PREVIEW_TICKET} />}>
                                    <Route path={RoutesMap.CLIENT_PREVIEW_TICKET} element={<ClientPreviewTicket />} />
                                </Route>
                                <Route element={<RestrictedRoute pathRequired={RoutesMap.DRIVER_LIST} />}>
                                    <Route path={RoutesMap.DRIVER_LIST} element={<DriverList />} />
                                </Route>
                                <Route element={<RestrictedRoute pathRequired={RoutesMap.PATENT_LIST} />}>
                                    <Route path={RoutesMap.PATENT_LIST} element={<PatentList />} />
                                </Route>
                            </Route>
                        </>
                    )
                }

            </Routes>

            <Toaster
                position="top-right"
                reverseOrder={false}
                toastOptions={{
                    style: {
                        background: "#c9c7c7",
                        color: "#fff",
                    },
                }}
            />

        </>
    )
}
export default App;
